<template>
  <div class="trademark-finder__trademark">
    <div>
      <p>
    Select a Trade Mark Class by entering your product or service here (Click on
    <a href="#" style="text-decoration: none; margin-left: -1px;" v-on:click="openPDF" class="definition-toggle">i</a>
    for more information)
  </p>
    </div>

    <FormulateInput
      type="text"
      placeholder="Start typing..."
      :class="['trademark-finder__trademark-search', { 'trademark-finder__trademark-search--active': searchValue.length && categories && inputFocused }]"
      :label-class="['formulate-input-label--tool-label']"
      :element-class="['formulate-input-element--tool-text', 'trademark-finder__trademark-input-wrapper']"
      v-model="searchValue"
      @focus="handleFocus"
      @blur="handleBlur"
    >

      <template #suffix>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          enable-background="new 0 0 500 500" height="25px" id="Layer_1" version="1.1" viewBox="0 0 500 500"
          width="25px" xml:space="preserve" class="lock-icon">
          <path clip-rule="evenodd"
            d="M131.889,150.061v63.597h-27.256  c-20.079,0-36.343,16.263-36.343,36.342v181.711c0,20.078,16.264,36.34,36.343,36.34h290.734c20.078,0,36.345-16.262,36.345-36.34  V250c0-20.079-16.267-36.342-36.345-36.342h-27.254v-63.597c0-65.232-52.882-118.111-118.112-118.111  S131.889,84.828,131.889,150.061z M177.317,213.658v-63.597c0-40.157,32.525-72.685,72.683-72.685  c40.158,0,72.685,32.528,72.685,72.685v63.597H177.317z M213.658,313.599c0-20.078,16.263-36.341,36.342-36.341  s36.341,16.263,36.341,36.341c0,12.812-6.634,24.079-16.625,30.529c0,0,3.55,21.446,7.542,46.699  c0,7.538-6.087,13.625-13.629,13.625h-27.258c-7.541,0-13.627-6.087-13.627-13.625l7.542-46.699  C220.294,337.678,213.658,326.41,213.658,313.599z"
            fill="#CECECE" fill-rule="evenodd" />
        </svg>

        <div class="trademark-finder__trademark-dropdown" v-if="searchValue.length && categories && inputFocused">
          <ul class="trademark-finder__trademark-list">
            <li v-for="(category, index) in categories" :key="index" @click="selectItem(category)"
              class="trademark-finder__trademark-list-item">
              <span>Class {{ category.class }}:</span>
              {{ category.description }}
            </li>
          </ul>
        </div>
      </template>
    </FormulateInput>

    <div class="trademark-finder__selected-trademark cat-num" v-for="(category, index) in selectedCategories" :key="index">
      <p class="trademark-finder__selected-trademark-copy"><span>Class {{ category.class }}:</span> {{ category.description }}
      </p>
      <a @click="remove_word($event)" :id="category.class" :class="['trademark-finder__selected-trademark-close']">
        <InlineSvg :src="require(`../../assets/svgs/close.svg`)" />
      </a>
    </div>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: 'TrademarkFinder',
  props: {
    categories: []
  },
  components: {
    InlineSvg
  },
  data() {
    return {
      searchValue: '',
      filteredCategories: [],
      selectedCategories: [],
      inputFocused: false,
    }
  },
  watch: {
    searchValue: function (data) {
      this.$emit('trademark-search-updated', data);
    },
    selectedCategories: function (data) {
      this.$emit('selected-trademarks-updated', data);
    },
  },
  methods: {
    selectItem(item) {
      let addedItem = { class: item.class, description: item.description };

      const itemAlreadySelected = this.selectedCategories.some(obj => {
        return obj.class === addedItem.class && obj.description === addedItem.description;
      });

      if (!itemAlreadySelected) {
        this.selectedCategories.push(addedItem);
      }

      this.searchValue = '';
    },
    remove_word(event) {
      console.log('hi!', event.currentTarget);
      this.selectedCategories = this.selectedCategories.filter(category => category.class !== event.currentTarget.id);
    },
    handleFocus() {
      this.inputFocused = true;
    },
    handleBlur() {
      // setTimeout so that we have time to add the selected item before the list is hidden
      setTimeout(() => (this.inputFocused = false), 250);
    },
    openPDF() {
      const pdfURL = '/ExplainerTrademarkSearch.pdf'; // Update the path if the PDF file is located in a different subdirectory of the `public` folder

      window.open(pdfURL, '_blank');
    },
  }
};
</script>
